import React from 'react';
import { PageSectionData } from '../../../../types/configuration';
import {
  Container,
  Flex,
  Grid,
  Group,
  Image,
  Stack,
  Text
} from '@mantine/core';
import Button from '../../../elements/Button';
import { formatTitle } from '../../../../utilities/dataFormat';
import LoaderContentItem from '../../../section/ContentSection/LoaderContentItem';
import ContentItem from '../../../section/ContentSection/ContentItem';
import IllustrationState from '../../IllustrationState';
import ContentCarousel from '../../../section/ContentSection/ContentCarousel';
import NoData from '../../../../assets/icon/illustrations_no-document.svg';

export interface SearchContentSectionProps extends PageSectionData {
  data: PageSectionData[];
  loading?: boolean;
  isSearch?: boolean;
  isDetail?: boolean;
  querysearch?: string;
  isUmum?: boolean;
}

const ContentSectionByCategory: React.FC<SearchContentSectionProps> = ({
  data,
  isSearch,
  querysearch,
  id,
  title,
  subtitle,
  isCarousel,
  loading: loadingState = false,
  isUmum = false,
  isButtonView
}) => {
  const contentList = data.filter((section) => section.id === id)[0]?.contents;

  if (contentList.length === 0) {
    return null;
  }
  return (
    <Container size={'xl'} w={'100%'} px={0}>
      <Flex direction={'column'} mb={6}>
        <Group align="center" justify="space-between">
          <Stack gap={0}>
            <Text fz={20} fw={700}>
              {isSearch
                ? contentList.length > 1
                  ? `Contents with Category ${querysearch}`
                  : `Content with Category ${querysearch}`
                : title || '-'}
            </Text>
            {isSearch ? (
              <Text fz={14} fw={500} c={'gray'}>
                {contentList.length} Results
              </Text>
            ) : (
              <Text fz={14} fw={500} c={'gray'}>
                {subtitle}
              </Text>
            )}
          </Stack>
          {isButtonView == 'Y' && contentList.length > 4 && (
            <Button
              variant="link"
              linkTo={
                isUmum
                  ? `/s/d?type=005&search=${querysearch}`
                  : isSearch
                  ? `/search/detail?type=005&search=${querysearch}`
                  : `/list/${formatTitle(title)}/005/${id}`
              }
            >
              View All
            </Button>
          )}
        </Group>

        {isSearch ? (
          <Grid mt={12} justify={'flex-start'}>
            {loadingState && (
              <>
                {[...Array(4)].map((_, i) => (
                  <Grid.Col span={{ base: 12, sm: 6, lg: 3 }} key={i}>
                    <LoaderContentItem />
                  </Grid.Col>
                ))}
              </>
            )}

            {!loadingState && contentList.length === 0 && (
              <Grid.Col span={12}>
                <IllustrationState
                  isIlustration={false}
                  Illustration={<Image src={NoData} w={'50%'} />}
                  description="No result found"
                />
              </Grid.Col>
            )}

            {!loadingState &&
              contentList.length > 0 &&
              contentList.map((content, i) => {
                return (
                  <ContentItem {...content} key={i} querysearch={querysearch} />
                );
              })}
          </Grid>
        ) : (
          <Grid mt={12} justify={'flex-start'}>
            {loadingState && (
              <>
                {[...Array(4)].map((_, i) => (
                  <Grid.Col span={{ base: 12, sm: 6, lg: 3 }} key={i}>
                    <LoaderContentItem />
                  </Grid.Col>
                ))}
              </>
            )}

            {!loadingState && contentList.length === 0 && (
              <Grid.Col span={12}>
                <IllustrationState
                  Illustration={<Image src={NoData} w={'50%'} />}
                  description="No data found"
                />
              </Grid.Col>
            )}

            {!loadingState &&
              contentList.length > 0 &&
              isCarousel === 'N' &&
              contentList.map((content, i) => {
                return <ContentItem {...content} key={i} />;
              })}
          </Grid>
        )}
        {!isSearch && (
          <>
            {!loadingState && contentList.length > 0 && isCarousel === 'Y' && (
              <ContentCarousel data={contentList} isCarousel={isCarousel} />
            )}
          </>
        )}
      </Flex>
    </Container>
  );
};

export default ContentSectionByCategory;
